module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="weather-forecast"><strong class="day">'+
((__t=( dayName))==null?'':__t)+
'</strong><strong class="day">'+
((__t=( time))==null?'':__t)+
' </strong><img src="';
 print(iconPath) 
__p+='"><div class="temperature ';
 if(temperature < 0){ 
__p+=' negative ';
 } 
__p+='">'+
((__t=( temperature ))==null?'':__t)+
'&#176;C</div><div class="wind-container"><div class="wind-arrow" style="background-position: '+
((__t=( backgroundPosition ))==null?'':__t)+
'"></div><div class="wind-speed">'+
((__t=( windSpeed ))==null?'':__t)+
'm/s</div></div></div>';
}
return __p;
};
